export default {
  label: 'Veloita palvelumaksu pöytätilauksista',
  description: 'Pöytätilauksista ei veloiteta palvelumaksua, ellei tämä ole päällä.',
  no_fee: 'Ravintolasi ei veloita palvelumaksua, joten pöytätilaukset eivät sisällä sitä myöskään.',
  partner_default_on: 'Kumppanin oletus: päällä',
  partner_default_off: 'Kumppanin oletus: pois',
  toasts: {
    on: 'Pöytätilauksista veloitetaan nyt palvelumaksu',
    off: 'Pöytätilauksista ei veloiteta nyt palvelumaksua',
    error: 'Tallennus epäonnistui. Yritä uudelleen.',
  },
};
